import {TutorialSvcFactory} from '../services/TutorialSvc';

class TutorialModal {
    constructor(private TutorialSvcFactory: TutorialSvcFactory) {
    }
}

angular.module('animatronApp.tutorial').component('tutorialModal', {
    controller: TutorialModal,
    templateUrl: require('tutorials/tutorial-modal.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/TutorialModal.ts